/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";

export default function AsyncFilter({
  value,
  onChange,
  searchURL,
  colourStyles,
  CustomOption,
  CustomValueContainer,
}) {
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const loadOptions = () => {
    clearTimeout(debounceTimer);
    setDebounceTimer(
      setTimeout(async () => {
        try {
          const res = await fetch(`${searchURL}${inputValue}`);
          const data = await res.json();
          setOptions(
            data.map((account) => ({
              value: account.id,
              label: account.name,
              customerId: account.customer_id,
            }))
          );
        } catch (error) {
          toast.error("Network error. Cannot fetch accounts information.");
          console.log(error);
        }
      }, 500)
    );
  };

  useEffect(() => {
    loadOptions();
  }, [inputValue, searchURL]);

  return (
    <Select
      placeholder="Search for accounts"
      classNamePrefix="react-select"
      isMulti
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={setInputValue}
      styles={colourStyles}
      closeMenuOnSelect={false}
      components={{
        ValueContainer: CustomValueContainer,
        Option: CustomOption,
      }}
      hideSelectedOptions={false}
    />
  );
}
